// This file is generated do not modify manually
export const orcoMiscellaneous = [
    { path: 'OrcoTravelNotice', loadChildren: () =>
    import('./orco-miscellaneous.module').then(m => m.OrcoMiscellaneousModule) },
    { path: 'OrcoAccountsBanner', loadChildren: () =>
    import('./orco-miscellaneous.module').then(m => m.OrcoMiscellaneousModule) },
    { path: 'OrcoContactForm', loadChildren: () =>
    import('./orco-miscellaneous.module').then(m => m.OrcoMiscellaneousModule) },
];
